import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

function BlogField() {
  const [tags, setTags] = useState([]); // Store all tags
  const [inputValue, setInputValue] = useState(""); // Store input value
  const [website, setField1] = useState(""); // Input for first column
  const [BlogTitle, setBlogTitle] = useState(""); // Input for second column
  const [BlogCategory, setField2] = useState(""); // Input for second column
  const [publisher_name, setField3] = useState(""); // Input for third column
  const [shortName, setShortName] = useState(""); // Input for third column
  const [PublishingStatus, setStatus] = useState(""); // Store Published/Unpublished status
  const [selectedImageURL, setSelectedImageURL] = useState("");
  const [imageOptions, setImageOptions] = useState([]);
  const [predefinedTags, setPredefinedTags] = useState([
    { tag: "gmart.in", selected: false },
    { tag: "network.gmart.in", selected: false },
    { tag: "automation.gmart.in", selected: false },
  ]);
  const navigate = useNavigate();
  let authtoken = localStorage.getItem('authToken')
  const handleInputChange = (e) => setInputValue(e.target.value);

  const handleKeyPress = (e) => {
    // debugger;
    if (e.key === "Enter" && inputValue.trim() !== "") {
      const newTag = inputValue.trim();

      // Check if the tag already exists in predefinedTags
      const isTagAlreadyPresent = predefinedTags.some(
        (item) => item.tag.toLowerCase() === newTag.toLowerCase()
      );

      if (!isTagAlreadyPresent) {
        // Add the new tag to predefinedTags and mark it as selected
        const newPredefinedTag = { tag: newTag, selected: true };
        setPredefinedTags([...predefinedTags, newPredefinedTag]);
        setTags([...tags, newTag]); // Add to selected tags
      } else {
        // If tag exists in predefinedTags, select it
        const updatedTags = predefinedTags.map((item) =>
          item.tag.toLowerCase() === newTag.toLowerCase()
            ? { ...item, selected: true }
            : item
        );
        setPredefinedTags(updatedTags);
        if (!tags.includes(newTag)) {
          setTags([...tags, newTag]);
        }
      }

      setInputValue("");
    }
  };
  const handleField1Change = (e) => setField1(e.target.value);
  const handleField2Change = (e) => setField2(e.target.value);
  const handleField4Change = (e) => setBlogTitle(e.target.value);
  const handleField3Change = (e) => setField3(e.target.value);
  const handleField5Change = (e) => setShortName(e.target.value);

  const handleRemoveTag = (indexToRemove) => {
    setTags(tags.filter((_, index) => index !== indexToRemove)); // Remove tag by index
  };
  const togglePredefinedTag = (index) => {
    const updatedTags = [...predefinedTags];
    updatedTags[index].selected = !updatedTags[index].selected;
    setPredefinedTags(updatedTags);

    const tagName = updatedTags[index].tag;
    if (updatedTags[index].selected) {
      if (!tags.includes(tagName)) {
        setTags([...tags, tagName]); // Add to selected tags
      }
    } else {
      setTags(tags.filter((tag) => tag !== tagName)); // Remove from selected tags
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://cms.gmart.in/media-listing', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authtoken}`,
          },
          body: JSON.stringify({
            pageSize: 100,
            folderPrefix: "assets/GMart-Blogs-images"
          }),
        });

        const data = await response.json();
        setImageOptions(data.contents)
        console.log(data);
      } catch (error) {
        console.error("Error fetching media:", error);
      }
    };

    fetchData(); // 👈 async function called inside useEffect

  }, []);



  const handleSubmit = () => {

    if (
      !website ||
      !shortName ||
      !BlogCategory ||
      !BlogTitle ||
      !selectedImageURL ||
      !publisher_name ||
      tags.length === 0 ||
      !PublishingStatus
    ) {
      alert("All fields are mandatory, including tags and status.");
      return;
    }

    const data = {
      tags,
      website,
      BlogCategory,
      publisher_name,
      PublishingStatus,
      BlogTitle,
      selectedImageURL,
      shortName
    };
    localStorage.setItem("blogData", JSON.stringify(data));
    navigate("/blogs/reactapp/edit");
  };

  return (
    <div className="container mt-5">

      <h2>
        <span style={{ color: "red" }}>*</span>Add Tags and Inputs
      </h2>

      <div className="form-group">
        <input
          type="text"
          className="form-control"
          placeholder="Type and press Enter to add a tag"
          value={inputValue}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
      </div>

      <div className="mt-3">
        {/* Predefined Tags */}
        {/* <h5>Predefined Tags:</h5> */}
        {predefinedTags.map((item, index) => (
          <span
            key={index}
            className="badge mx-1"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "10px",
              borderRadius: "20px",
              backgroundColor: item.selected ? "#87CEEB" : "#F0F0F0", // Highlight selected
              color: item.selected ? "white" : "black",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            onClick={() => togglePredefinedTag(index)}
          >
            {item.tag}
          </span>
        ))}
      </div>

      <div className="col-md-4 mt-4">
        <h6><span style={{ color: "red" }}>*</span>Enter Blog Title</h6>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Blog Title"
          value={BlogTitle}
          onChange={handleField4Change}
        />
      </div>

      <div className="col-md-4 mt-4">
        <h6><span style={{ color: "red" }}>*</span>Enter Title Short Name</h6>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Title Short Name"
          value={shortName}
          onChange={handleField5Change}
        />
      </div>

      <div className="col-md-8 mt-4">
        <h6><span style={{ color: "red" }}>*</span>Select Blog Cover Image</h6>
        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedImageURL ? "Change Image" : "Select Image"}
          </button>
          <ul className="dropdown-menu" style={{ maxHeight: "300px", overflowY: "auto", width: 300 }}>
            {imageOptions.map((url, index) => (
              <li key={index} className="px-2 py-1" onClick={() => setSelectedImageURL(url)} style={{ cursor: "pointer" }}>
                <img src={url} alt={`Preview ${index}`} style={{ width: "200px", height: "auto" }} />
              </li>
            ))}
          </ul>
        </div>

        {selectedImageURL && (
          <div className="mt-2">
            <p className="mb-1"><strong>Selected Image:</strong></p>
            <img src={selectedImageURL} alt="Selected Preview" style={{ width: "120px", borderRadius: "8px" }} />
          </div>
        )}
      </div>


      {/* <div className="mt-3">
        {/* User-added Tags */}
      {/* <h5>Added Tags:</h5>
        {tags.map((tag, index) => (
          <span
            key={index}
            className="badge mx-1"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "10px",
              borderRadius: "20px",
              backgroundColor: "#add8e6", // Light blue background
              color: "black",
              fontWeight: "bold",
            }}
          >
            {tag}
            <button
              type="button"
              className="btn btn-sm btn-light ml-2"
              style={{ borderRadius: "50%", padding: "0 8px" }}
              onClick={() => handleRemoveTag(index)}
            >
              &times;
            </button>
          </span>
        ))}
      </div> */}



      <div className="col mt-4">
        {/* <div className="col-md-4">
          <h6><span style={{ color: "red" }}>*</span>Enter Website Name</h6>
          <input
            type="text"
            className="form-control"
            placeholder="Field 1"
            value={website}
            onChange={handleField1Change}
          />
        </div> */}
        <div className="col-md-4">
          <h6>
            <span style={{ color: "red" }}>*</span>Enter Website Name
          </h6>
          <select
            className="form-control"
            value={website}
            onChange={handleField1Change}
          >
            <option value="" disabled>
              Select Website
            </option>
            <option value="gmart.in">gmart.in</option>
            <option value="encriss.com">encriss.com</option>
            <option value="automation.gmart.in">automation.gmart.in</option>
            <option value="network.gmart.in">network.gmart.in</option>
            <option value="devices.encriss.com">devices.encriss.com</option>
            <option value="testing.in">testing.in</option>
            <option value="emprise.gmart.in">emprise.gmart.in</option>
            <option value="admin.gmart.in">admin.gmart.in</option>

          </select>
        </div>
        <br />
        <div className="col-md-4">
          <h6><span style={{ color: "red" }}>*</span>Enter Blog Category</h6>
          <input
            type="text"
            className="form-control"
            placeholder="Field 2"
            value={BlogCategory}
            onChange={handleField2Change}
          />
        </div>
        <br />
        <div className="col-md-4">
          <h6><span style={{ color: "red" }}>*</span>Enter Publisher name</h6>
          <input
            type="text"
            className="form-control"
            placeholder="Field 3"
            value={publisher_name}
            onChange={handleField3Change}
          />
        </div>
      </div>

      <div className="mt-4">
        <h6><span style={{ color: "red" }}>*</span>Status</h6>
        <button
          className={`btn ${PublishingStatus === "Published"
            ? "btn-success"
            : "btn-outline-success"
            }`}
          style={{ marginRight: "15px" }} // Gap between buttons
          onClick={() => setStatus("Published")}
        >
          Published
        </button>
        <button
          className={`btn ${PublishingStatus === "Unpublished"
            ? "btn-danger"
            : "btn-outline-danger"
            }`}
          onClick={() => setStatus("Unpublished")}
        >
          Draft
        </button>
      </div>

      <button className="btn btn-primary mt-3" onClick={handleSubmit}>
        Submit Data
      </button>
    </div>
  );
}

export default BlogField;
